import {PrFormControlType} from '../../enums/process-reports/pr-form-control-type.enum';
import {PrFormControl} from '../../interfaces/process-reports/pr-form-control';
import {PrFormControlOption} from '../../interfaces/process-reports/pr-form-control-option';
import {PrFormControlOptionFactory} from './pr-form-control-option-factory';
import {PrInputGroup} from '../../interfaces/process-reports/pr-input-group';
import {PrInputGroupFactory} from './pr-input-group-factory';
import {PrLabelType} from '../../enums/process-reports/pr-label-type';
import {PrType} from '../../interfaces/process-reports/pr-type';
import {PrTypeFactory} from './pr-type-factory';

export class PrFormControlFactory {

  /**
   *
   * @param prFormControl
   */
  public static fromObject(prFormControl: any): PrFormControl {
    return new class implements PrFormControl {
      id: number = prFormControl.id;
      label: string = prFormControl.label;
      labelType: 'label' | 'placeholder' = prFormControl.label_type;
      max: number = prFormControl.max;
      maxDate: string = prFormControl.max_date;
      maxLength: number = prFormControl.max_length;
      rights: number = prFormControl.rights;
      min: number = prFormControl.min;
      minDate: string = prFormControl.min_date;
      minLength: number = prFormControl.min_length;
      order: number = prFormControl.order;
      required: boolean = prFormControl.required;
      size: number = prFormControl.size;
      step: number = prFormControl.step;
      type: PrFormControlType = prFormControl.type;
      version: number = prFormControl.version;
      integer: boolean = prFormControl.integer;
      float: boolean = prFormControl.float;
      prType: PrType = prFormControl.pr_type ? PrTypeFactory.fromObject(prFormControl.pr_type) : null;
      prLabelType: PrLabelType = prFormControl.pr_label_type;
      prInputGroupId: number = prFormControl.pr_input_group_id;
      prInputGroup: PrInputGroup = prFormControl.pr_input_group ? PrInputGroupFactory.fromObject(prFormControl.pr_input_group) : null;
      prFormControlOptions: PrFormControlOption[] = PrFormControlOptionFactory.fromArray(prFormControl.pr_form_control_options);
      rows: number = prFormControl.rows;
      dateTimeDefault: 'now' = prFormControl.date_time_default;
    };
  }

  /**
   *
   * @param prFormControls
   */
  public static fromArray(prFormControls: any[]): PrFormControl[] {
    return prFormControls.map(_prFormControl => PrFormControlFactory.fromObject(_prFormControl));
  }
}
